import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Foundation/unicodesMap.json';
export default createIconSet(glyphMap, 'Foundation', require('~/../assets/fonts/Foundation/Foundation.ttf'));
